// Type imports:
import { AlertStatus, IAlert, IAlertConfig, IAlertDataUserInfo } from '../api/AlertTypes';

/* REQUEST ALERTS */
export const REQUEST_ALERTS_WAITING = 'REQUEST_ALERTS_WAITING';
export const REQUEST_ALERTS_SUCCESS = 'REQUEST_ALERTS_SUCCESS';
export const REQUEST_ALERTS_FAILURE = 'REQUEST_ALERTS_FAILURE';

interface IRequestAlertsWaitingAction {
    type: typeof REQUEST_ALERTS_WAITING,
    payload: {
        fromDate: string,
        toDate: string
    }
}

interface IRequestAlertsSuccessAction {
    type: typeof REQUEST_ALERTS_SUCCESS,
    payload: {
        fromDate: string,
        toDate: string
        alerts: Array<IAlert>
    }
}

interface IRequestAlertsFailureAction {
    type: typeof REQUEST_ALERTS_FAILURE,
    payload: {
        fromDate: string,
        toDate: string
        error: string
    }
}

/* REQUEST ALERT CONFIGS */
export const REQUEST_ALERT_CONFIGS_WAITING = 'REQUEST_ALERT_CONFIGS_WAITING';
export const REQUEST_ALERT_CONFIGS_SUCCESS = 'REQUEST_ALERT_CONFIGS_SUCCESS';
export const REQUEST_ALERT_CONFIGS_FAILURE = 'REQUEST_ALERT_CONFIGS_FAILURE';

interface IRequestAlertConfigsWaitingAction {
    type: typeof REQUEST_ALERT_CONFIGS_WAITING,
}

interface IRequestAlertConfigsSuccessAction {
    type: typeof REQUEST_ALERT_CONFIGS_SUCCESS,
    payload: {
        alertConfigs: Array<IAlertConfig>
    }
}

interface IRequestAlertConfigsFailureAction {
    type: typeof REQUEST_ALERT_CONFIGS_FAILURE,
    payload: {
        error: string
    }
}

/* MODIFY ALERT CONFIGS */
export const MODIFY_ALERT_CONFIGS_SUCCESS = 'MODIFY_ALERT_CONFIGS_SUCCESS';
export const MODIFY_ALERT_CONFIGS_FAILURE = 'MODIFY_ALERT_CONFIGS_FAILURE';

interface IModifyAlertConfigsSuccessAction {
    type: typeof MODIFY_ALERT_CONFIGS_SUCCESS,
    payload: {
        newAlertConfigs: Array<IAlertConfig>
    }
}

interface IModifyAlertConfigsFailureAction {
    type: typeof MODIFY_ALERT_CONFIGS_FAILURE,
    payload: {
        error: string
    }
}

/* SET SELECTED STATUSES */
export const SET_SELECTED_STATUS = 'SET_SELECTED_STATUS';

interface ISetSelectedStatuses {
    type: typeof SET_SELECTED_STATUS,
    payload: {
        status: AlertStatus | null,
        skipPushingToHistory: boolean
    }
}

/* REQUEST ALERT REVIEW HISTORY */
export const REQUEST_ALERT_REVIEW_HISTORY_WAITING = 'REQUEST_ALERT_REVIEW_HISTORY_WAITING';
export const REQUEST_ALERT_REVIEW_HISTORY_SUCCESS = 'REQUEST_ALERT_REVIEW_HISTORY_SUCCESS';
export const REQUEST_ALERT_REVIEW_HISTORY_FAILURE = 'REQUEST_ALERT_REVIEW_HISTORY_FAILURE';

interface IRequestAlertReviewHistoryWaitingAction {
    type: typeof REQUEST_ALERT_REVIEW_HISTORY_WAITING,
    payload: {
        alertDataId: number
    }
}

interface IRequestAlertReviewHistorySuccessAction {
    type: typeof REQUEST_ALERT_REVIEW_HISTORY_SUCCESS,
    payload: {
        alertDataId: number,
        alertReviewHistory: Array<IAlertDataUserInfo>
    }
}

interface IRequestAlertReviewHistoryFailureAction {
    type: typeof REQUEST_ALERT_REVIEW_HISTORY_FAILURE,
    payload: {
        alertDataId: number,
        error: string
    }
}

/* ADD ALERT REVIEW HISTORY ENTRY */
export const ADD_ALERT_REVIEW_HISTORY_ENTRY_SUCCESS = 'ADD_ALERT_REVIEW_HISTORY_ENTRY_SUCCESS';
export const ADD_ALERT_REVIEW_HISTORY_ENTRY_FAILURE = 'ADD_ALERT_REVIEW_HISTORY_ENTRY_FAILURE';

interface IAddAlertReviewHistoryEntrySuccessAction {
    type: typeof ADD_ALERT_REVIEW_HISTORY_ENTRY_SUCCESS,
    payload: {
        newAlertReviewHistoryEntries: Array<IAlertDataUserInfo>
    }
}

interface IAddAlertReviewHistoryEntryFailureAction {
    type: typeof ADD_ALERT_REVIEW_HISTORY_ENTRY_FAILURE,
    payload: {
        error: string
    }
}

/* EXPORT */
export type AlertActions =
IRequestAlertsWaitingAction
| IRequestAlertsSuccessAction
| IRequestAlertsFailureAction
| IRequestAlertConfigsWaitingAction
| IRequestAlertConfigsSuccessAction
| IRequestAlertConfigsFailureAction
| IModifyAlertConfigsSuccessAction
| IModifyAlertConfigsFailureAction
| ISetSelectedStatuses
| IRequestAlertReviewHistoryWaitingAction
| IRequestAlertReviewHistorySuccessAction
| IRequestAlertReviewHistoryFailureAction
| IAddAlertReviewHistoryEntrySuccessAction
| IAddAlertReviewHistoryEntryFailureAction;